import { useEffect, useState } from "react";
import { INTAKE_COOLDOWN_EVENT, currentIntakeRetryAt } from "../utils/intakeLimits";

/** One shared tab-local countdown; expiry only re-enables controls, never sends a request. */
const useIntakeCooldown = (localRetryAt = 0) => {
  const [clock, setClock] = useState(() => ({ now: Date.now() }));
  const retryAt = currentIntakeRetryAt(clock.now);
  useEffect(() => {
    const update = () => setClock({ now: Date.now() });
    window.addEventListener(INTAKE_COOLDOWN_EVENT, update);
    return () => window.removeEventListener(INTAKE_COOLDOWN_EVENT, update);
  }, []);
  useEffect(() => {
    if (Math.max(retryAt, localRetryAt) <= clock.now) return undefined;
    const timer = setInterval(() => setClock({ now: Date.now() }), 1000);
    return () => clearInterval(timer);
  }, [retryAt, localRetryAt, clock]);
  return {
    blocked: retryAt > clock.now,
    retryAt,
    now: clock.now,
    secondsRemaining: Math.max(0, Math.ceil((retryAt - clock.now) / 1000)),
  };
};

export default useIntakeCooldown;
